import './assets/global.css';

import { App } from 'antd';

import Clarity from '@microsoft/clarity';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AuthSessionSync from 'components/Shared/AuthSessionSync';
import Routes from 'Routes';
import { CLARITY_ID, ENV } from 'settings';

import { ThemeProvider } from '@eduzz/ui-antd-theme';

import GoogleMapsLib from './services/GoogleMapsLib';

declare global {
  interface Window {
    google?: any;
  }
}

const queryClient = new QueryClient();

function getInitialMode(): 'light' | 'dark' {
  const modeParam = new URLSearchParams(window.location.search).get('eduzzMode');
  if (modeParam === 'light' || modeParam === 'dark') return modeParam;

  return document.cookie.includes('eduzz-theme=dark') ? 'dark' : 'light';
}

const initialMode = getInitialMode();

const AppRoot = () => {
  if (ENV === 'production') {
    Clarity.init(CLARITY_ID);
  }

  console.log('(Front) Version Number: 1236 / Branch: master / Commit: 4297be29dd');

  return (
    <ThemeProvider mode={initialMode} enableAnimation>
      <QueryClientProvider client={queryClient}>
        <AuthSessionSync />
        <App notification={{ placement: 'topRight', duration: 6 }}>
          <GoogleMapsLib />
          <Routes />
          <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' />
        </App>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default AppRoot;
